import React from 'react';
import { useSharedLinks } from './hooks/useSharedLinks';
import {
  CreateLinkButtons,
  LinkList,
  CreateLinkDialog,
  DeleteLinkDialog,
} from './components';

export function SharedLinks() {
  const {
    user,
    sortedLinks,
    linkToDelete,
    copiedLinkId,
    newLinkId,
    showCreateDialog,
    setLinkToDelete,
    setShowCreateDialog,
    handleCreateLink,
    handleCopyLink,
    handleToggleStatus,
    handleDeleteLink,
  } = useSharedLinks();

  return (
    <div className="h-full flex flex-col">
      <div className="flex-shrink-0 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <h2 className="text-2xl font-bold text-gray-900">الروابط المشتركة</h2>
        {user?.role === 'admin' && (
          <CreateLinkButtons
            onCreateAdd={() => setShowCreateDialog('add')}
            onCreateInfo={() => setShowCreateDialog('info')}
          />
        )}
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="bg-white shadow-sm rounded-lg divide-y">
          <LinkList
            links={sortedLinks}
            isAdmin={user?.role === 'admin'}
            newLinkId={newLinkId}
            copiedLinkId={copiedLinkId}
            onToggleStatus={handleToggleStatus}
            onDelete={setLinkToDelete}
            onCopy={handleCopyLink}
          />
        </div>
      </div>

      {showCreateDialog && (
        <CreateLinkDialog
          open={true}
          onClose={() => setShowCreateDialog(null)}
          onSubmit={handleCreateLink}
          type={showCreateDialog}
        />
      )}

      <DeleteLinkDialog
        open={!!linkToDelete}
        onClose={() => setLinkToDelete(null)}
        onConfirm={handleDeleteLink}
      />
    </div>
  );
}